var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.08C17.74 16.08 17.06 16.38 16.54 16.85L9.41 12.7C9.46 12.47 9.5 12.24 9.5 12C9.5 11.76 9.46 11.53 9.41 11.3L16.46 7.19C17 7.69 17.71 8 18.5 8C20.16 8 21.5 6.66 21.5 5C21.5 3.34 20.16 2 18.5 2C16.84 2 15.5 3.34 15.5 5C15.5 5.24 15.54 5.47 15.59 5.7L8.54 9.81C8 9.31 7.29 9 6.5 9C4.84 9 3.5 10.34 3.5 12C3.5 13.66 4.84 15 6.5 15C7.29 15 8 14.69 8.54 14.19L15.66 18.34C15.61 18.55 15.58 18.77 15.58 19C15.58 20.61 16.89 21.91 18.5 21.91C20.11 21.91 21.42 20.61 21.42 19C21.42 17.39 20.11 16.08 18.5 16.08ZM18.5 4C19.05 4 19.5 4.45 19.5 5C19.5 5.55 19.05 6 18.5 6C17.95 6 17.5 5.55 17.5 5C17.5 4.45 17.95 4 18.5 4ZM6.5 13C5.95 13 5.5 12.55 5.5 12C5.5 11.45 5.95 11 6.5 11C7.05 11 7.5 11.45 7.5 12C7.5 12.55 7.05 13 6.5 13ZM18.5 20C17.95 20 17.5 19.55 17.5 19C17.5 18.45 17.95 18 18.5 18C19.05 18 19.5 18.45 19.5 19C19.5 19.55 19.05 20 18.5 20Z",
    fill: "#2D4B9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3d7314b8c812c4af1c288488d7fda3dd.svg";
export { ForwardRef as ReactComponent };